module.exports = __webpack_public_path__ + "976c98d95aa3cef5ec71652737becca6.png";